import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { registerViewsKeys } from '../registerViewKeys'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import {
  IRegisterView,
  RegisterView,
} from '@core/entities/register/RegisterView'

const viewTransform = (response: IRegisterView) => RegisterView.new(response)

export const useGetRegisterTemplateView = (
  payload: RequestTypes['getRegisterTemplateView'],
  options?: UseQueryOptions<IRegisterView, RequestErrorType, RegisterView>,
) => {
  return useQuery({
    select: viewTransform,
    ...registerViewsKeys.byId(payload),
    ...options,
  })
}
